import camelcaseKeys from 'camelcase-keys';
import { formatToRequestParameter } from 'utils/formatting';
import apiGateway from '../axios';
import {
  IGetNandaClass,
  IGetNandaDiagnosis,
  ICreateNursingRecord,
  IGetNursingRecords,
  IDeleteNursingRecord,
  IUpdateNursingRecord,
  IGetClassList,
} from './type';

export const getNandaDomain = () => {
  const url = `/main/nanda/domain`;
  return apiGateway.get(url);
};

export const getNandaClass = (request: IGetNandaClass) => {
  const url = `/main/nanda/class_en?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const getNandaDiagnosis = (request: IGetNandaDiagnosis) => {
  const url = `/main/nanda/diagnosis_en?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const createNursingRecord = (request: ICreateNursingRecord) => {
  const url = `/main/create/nursing_record`;
  return apiGateway.post(url, request);
};

export const deleteNursingRecord = (request: IDeleteNursingRecord) => {
  const url = `/main/delete/nursing_record?${formatToRequestParameter(
    request
  )}`;
  return apiGateway.post(url);
};

export const updateNursingRecord = (request: IUpdateNursingRecord) => {
  const url = `/main/update/nursing_record`;
  return apiGateway.post(url, camelcaseKeys(request));
};

export const getNursingRecords = (request: IGetNursingRecords) => {
  const url = `/main/nursing_records?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

// 분반 관련
export const getProfessorClassSection = (request: number) => {
  const url = `/main/class_section?user_id=${request}`;
  return apiGateway.get(url);
};

export const getClassSectionList = (request: IGetClassList) => {
  const url = `/main/class_section_list?page=${request.page}&user_id=${request.user_id}&size=${request.size}`;
  return apiGateway.get(url);
};

export const createClassSection = (id: number, formData: any) => {
  const url = `/main/create/class_section?user_id=${id}`;
  return apiGateway.post(url, formData);
};

export const updateClassSection = (id: number, formData: any) => {
  const url = `/main/update/class_section?user_id=${id}`;
  return apiGateway.post(url, formData);
};

export const deleteClassSection = (id: number, class_section_id: number) => {
  const url = `/main/delete/class_section?user_id=${id}&class_section_id=${class_section_id}`;
  return apiGateway.delete(url);
};

// 전체 학생 조회
export const getClassSectionStudent = (
  id: number,
  searchType: number,
  patient_id?: number
) => {
  const url = `/main/class_section_students?user_id=${id}&searchType=${searchType}&patient_id=${patient_id}`;
  return apiGateway.get(url);
};

// 분반에 속한 학생만 조회
export const getSpecificClassSection = (
  id: number,
  searchType: number,
  class_section_id: number,
  patientId?: number
) => {
  const url = `/main/class_section_students?user_id=${id}&searchType=${searchType}&class_section_id=${class_section_id}&patient_id=${patientId}`;
  return apiGateway.get(url);
};
